import styled from 'styled-components';

import { DropdownIcon, Radio, SearchInput, Tabs } from '@libs/components';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 2rem;
  ${({ theme }) => theme.media.tablet`
  padding: 1.6rem 3.6rem 3.6rem 3.6rem;

  `};
`;

export const ArrowIcon = styled(DropdownIcon)`
  transform: rotate(-90deg);
`;

export const CustomRadio = styled(Radio)`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;

export const AsssetsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.2rem;
  /* margin-top: 1.2rem; */
  align-items: center;
`;

export const WithdrawAssetsWrapper = styled(AsssetsWrapper)`
  margin-top: 1.2rem;
`;

type AssetsTitleWrapperProps = {
  noBottomMargin?: boolean;
};

export const AssetsTitleWrapper = styled.div<AssetsTitleWrapperProps>`
  display: flex;
  margin-top: 2rem;
  margin-bottom: ${({ noBottomMargin }) =>
    noBottomMargin ? 'none' : '1.2rem'};
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 1.2rem;
`;

export const BalanceCurrencyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 2rem;
`;

export const BalanceCurrencyTabsWrapper = styled.div`
  max-width: 11.7rem;
  width: 100%;
`;

export const CustomTabs = styled(Tabs)`
  height: 3.4rem;

  .tab-highlighter {
    height: 2.6rem;
  }
`;
export const CustomCurrencyTabs = styled(Tabs)`
  height: 3.4rem;

  .tab-highlighter {
    height: 2.6rem;
  }
`;

export const CustomSearchInput = styled(SearchInput)`
  border-radius: ${({ theme }) => theme.borderRadius.x8};
`;
